import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Card from "../components/blog/card/card"
import BlogNav from "../components/blog/nav/nav"

import Layout from "../components/layout"
import SEO from "../components/seo"


const Blog = () => {

  const data = useStaticQuery(graphql`
    query {
      allDibPosts {
        edges {
          node {
            title
            summary
            slug
            publishedAt
            readtime
            featuredImage
            categories {
              title
              slug
            }
            author {
              name
              slug
              photo
            }
          }
        }
      }
    }
    `);
 const posts = data?.allDibPosts?.edges


  return (
    <Layout>
      <SEO title="Blog" />
      <div className="content-wrapper">
        <div className="container-fluid">
          <div className="blog-header">
            <h2>Blog</h2>
            <BlogNav />
          </div>
          <div className="row gutter-lg">
            {posts.map((post, index) => (
              <div key={index} className="col-sm-6 col-md-6 mb-3">
                <Card post={post.node} tab={post.node.categories[0]} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )

}
export default Blog
